import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouterProvider } from "react-router/dom";
import { LoaderSimpleIcon } from "qw-ui-lib-v2/icons";
import { authenticateUser } from "./features/auth/authManager";
import { setCredentials } from "./features/auth/authSlice";
import { setAxiosBearerToken } from "./app/clients/axiosClientSetup";
import { PageLogout } from "./app/layouts/PageLogout";
import { router } from "./app/routes.js";
import "qw-ui-lib-v2/build/index.css";
import "./styles/index.scss";

export default function App() {
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    authenticateUser().then((response) => {
      dispatch(setCredentials(response));
      setAxiosBearerToken(response?.accessToken);
    });
  }, [dispatch]);

  if (authState.isLoggedOut) {
    return <PageLogout />;
  }

  if (!authState.isAuthenticated) {
    return <LoaderSimpleIcon className="page-loader" />;
  }

  return <RouterProvider router={router} />;
}
